import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import LoginPage from './components/login';
import PageLayout from './components/dashboard';
import AuthCallback from './pages/auth/AuthCallback';
import { Routes, Route, useNavigate, Navigate} from "react-router-dom";
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import axiosInstance from './utils/axiosInstance';


function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth <= 768 ? false : true);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768 ? true : false);
  const [loggedIn, setLoggedIn] = useState(() => localStorage.getItem('login') || 'false');
  const navigate = useNavigate();
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // useEffect(() => {
  //     const handleResize = () => {
  //         const isMobile = window.innerWidth <= 768;
  //         setIsMobileView(isMobile);
  //         setIsSidebarOpen(!isMobile);
  //     };
  //     handleResize();

  //     window.addEventListener('resize', handleResize);

  //     return () => {
  //         window.removeEventListener('resize', handleResize);
  //     };
  // }, []);
  useEffect(() => {
    let logInfo = localStorage.getItem('login')
    setLoggedIn(logInfo)
    if (logInfo === 'false') {
      navigate('/')
    }
  }, [localStorage.getItem('login')])

  // Validate session on app load - if session expired in backend, force logout
  useEffect(() => {
    if (localStorage.getItem('login') === 'true' && localStorage.getItem('session_token')) {
      axiosInstance.post('/auth/refresh', {}).catch(() => {});
    }
  }, []);

  const location = useLocation();
  return (
    <div className="App">
      <Container fluid className={`page-layout px-0 ${isMobileView ? 'mobile-view' : ''}`}>
        <div className='main-home'>
          <Routes>
            <Route
              exact path="/"
              element={
                loggedIn === 'true' ? (
                  <><Navigate to={"/home"} replace /></>
                ) : (
                  <LoginPage />
                )
              }
            />
            {/* OAuth2 + 2FA callback — always accessible, no auth guard */}
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/home/*"
              element={loggedIn === 'false' ? (
                <Navigate to={"/"} replace />
              ) : <PageLayout location={location}/>
              }
            />
            <Route path='/home/:action' element={<PageLayout location={location}/>} />
          </Routes>
          <ToastContainer style={{ zIndex: 1000000000000 }} />
          <Tooltip id="my-tooltip" style={{
            whiteSpace: "normal",
            maxWidth:"500px"
          }} />
        </div>
      </Container>
    </div>
  );
}

export default App;
